import { render } from "./CreateTaskNote.vue?vue&type=template&id=4e3d19d9"
import script from "./CreateTaskNote.vue?vue&type=script&lang=js"
export * from "./CreateTaskNote.vue?vue&type=script&lang=js"

import "./CreateTaskNote.vue?vue&type=style&index=0&id=4e3d19d9&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__